import { larguraColunaCodigo, larguraColunaDescricao, larguraColunaOrdem, larguraColunaReferencia, larguraPrimeiraColuna } from "./largurasColunasFixas";
import { IColuna } from "app/types/IColuna";

const estiloPadrao: React.CSSProperties = {
    position: "sticky",
    backgroundColor: "var(--mu-superficie-forte, #daddde)",
    zIndex: 1
};

const nomesColunasFixas = new Set(["OrdemItem", "Codigo", "Referencia", "Descricao"]);

const encontrarColuna = (nome, colunas) => colunas.find(c => c.Nome === nome);

export const obterStyleColunasFixas = (nomeColuna: string, todasColunas: IColuna[], parametro_CHAVE_MOVIMENTACAO_ORCAMENTO: "C" | "R", subItemTinta: boolean): React.CSSProperties => {
    const larguraColunaOrdem_ = () => encontrarColuna("OrdemItem", todasColunas)?.Selecionada ? larguraColunaOrdem : 0;
    const larguraColunaCodigo_ = () => encontrarColuna("Codigo", todasColunas)?.Selecionada ? larguraColunaCodigo : 0;
    const larguraColunaReferencia_ = () => encontrarColuna("Referencia", todasColunas)?.Selecionada ? larguraColunaReferencia : 0;
    const larguraColunaDescricao_ = () => encontrarColuna("Descricao", todasColunas)?.Selecionada ? larguraColunaDescricao : 0;

    const colunasCodigoEReferenciaExistem = encontrarColuna("Codigo", todasColunas) && encontrarColuna("Referencia", todasColunas);

    const estiloEspecifico: React.CSSProperties = !nomeColuna ? {
        minWidth: larguraPrimeiraColuna,
        maxWidth: larguraPrimeiraColuna,
        left: 0
    } : nomeColuna === "OrdemItem" ? {
        minWidth: larguraColunaOrdem,
        maxWidth: larguraColunaOrdem,
        left: larguraPrimeiraColuna
    } : nomeColuna === "Codigo" ? {
        minWidth: larguraColunaCodigo,
        maxWidth: larguraColunaCodigo,
        borderRight: subItemTinta ? "2px dashed var(--mu-borda-forte, black)" : null,
        left: larguraPrimeiraColuna + (
            colunasCodigoEReferenciaExistem && parametro_CHAVE_MOVIMENTACAO_ORCAMENTO === "C" ? larguraColunaOrdem_() :
            colunasCodigoEReferenciaExistem && parametro_CHAVE_MOVIMENTACAO_ORCAMENTO === "R" ? larguraColunaOrdem_() + larguraColunaReferencia_() + larguraColunaDescricao_() :
            !colunasCodigoEReferenciaExistem ? larguraColunaOrdem_() : 0
        )
    } : nomeColuna === "Referencia" ? {
        minWidth: larguraColunaReferencia,
        maxWidth: larguraColunaReferencia,
        borderRight: subItemTinta ? "2px dashed var(--mu-borda-forte, black)" : null,
        left: larguraPrimeiraColuna + (
            colunasCodigoEReferenciaExistem && parametro_CHAVE_MOVIMENTACAO_ORCAMENTO === "R" ? larguraColunaOrdem_() :
            colunasCodigoEReferenciaExistem && parametro_CHAVE_MOVIMENTACAO_ORCAMENTO === "C" ? larguraColunaOrdem_() + larguraColunaCodigo_() + larguraColunaDescricao_() :
            !colunasCodigoEReferenciaExistem ? larguraColunaOrdem_() : 0
        )
    } : nomeColuna === "Descricao" ? {
        minWidth: larguraColunaDescricao,
        maxWidth: larguraColunaDescricao,
        left: larguraPrimeiraColuna + larguraColunaOrdem_() + (
            parametro_CHAVE_MOVIMENTACAO_ORCAMENTO === "C" ? larguraColunaCodigo_() :
            parametro_CHAVE_MOVIMENTACAO_ORCAMENTO === "R" ? larguraColunaReferencia_() : 0
        )
    } : {};

    return !nomeColuna || nomesColunasFixas.has(nomeColuna) ? {
        ...estiloPadrao,
        ...estiloEspecifico
    } : {};
};

export const obterStylePrimeiraColuna = (): React.CSSProperties => ({
    ...estiloPadrao,
    minWidth: larguraPrimeiraColuna,
    left: 0
});
